"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WalletContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ethers = require("ethers");
var _wallet = require("@dsc/utils/wallet");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // packages/ui/hooks/WalletContext.js
var WalletContext = exports.WalletContext = /*#__PURE__*/(0, _react.createContext)();
var DEFAULT_CHAIN_ID = "0x13882"; // Polygon Amoy Testnet

var WalletProvider = function WalletProvider(_ref) {
  var children = _ref.children,
    _ref$targetChainId = _ref.targetChainId,
    targetChainId = _ref$targetChainId === void 0 ? DEFAULT_CHAIN_ID : _ref$targetChainId;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    address = _useState2[0],
    setAddress = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    provider = _useState4[0],
    setProvider = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    signer = _useState6[0],
    setSigner = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    connecting = _useState8[0],
    setConnecting = _useState8[1];
  var _useState9 = (0, _react.useState)(""),
    _useState0 = _slicedToArray(_useState9, 2),
    error = _useState0[0],
    setError = _useState0[1];

  // 🧠 Core connect function
  var connectWallet = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var accounts, prov, sig, acc, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            setConnecting(true);
            setError("");
            if ((0, _wallet.hasMetaMask)()) {
              _context.n = 1;
              break;
            }
            throw new Error("Please install MetaMask.");
          case 1:
            _context.n = 2;
            return (0, _wallet.ensureChain)(targetChainId);
          case 2:
            _context.n = 3;
            return window.ethereum.request({
              method: "wallet_requestPermissions",
              params: [{
                eth_accounts: {}
              }]
            });
          case 3:
            _context.n = 4;
            return window.ethereum.request({
              method: "eth_requestAccounts"
            });
          case 4:
            accounts = _context.v;
            if (!(!accounts || accounts.length === 0)) {
              _context.n = 5;
              break;
            }
            throw new Error("No accounts found. Please unlock MetaMask.");
          case 5:
            prov = new _ethers.BrowserProvider(window.ethereum);
            _context.n = 6;
            return prov.getSigner();
          case 6:
            sig = _context.v;
            _context.n = 7;
            return sig.getAddress();
          case 7:
            acc = _context.v;
            setProvider(prov);
            setSigner(sig);
            setAddress(acc);

            // Expose for debug
            window.dscProvider = prov;
            window.dscSigner = sig;
            window.dscAddress = acc;
            console.log("\u2705 Connected wallet: ".concat(acc));
            _context.n = 9;
            break;
          case 8:
            _context.p = 8;
            _t = _context.v;
            console.error("Wallet connect error:", _t);
            setError(_t.message || "Connection failed. Please try again.");
          case 9:
            _context.p = 9;
            setConnecting(false);
            return _context.f(9);
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[0, 8, 9, 10]]);
    }));
    return function connectWallet() {
      return _ref2.apply(this, arguments);
    };
  }();

  // 🧩 Handle account switching dynamically
  (0, _react.useEffect)(function () {
    if (!(0, _wallet.hasMetaMask)()) return;
    var handleAccountChange = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(accounts) {
        var acc, prov, sig;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(accounts && accounts.length > 0)) {
                _context2.n = 2;
                break;
              }
              acc = accounts[0];
              prov = new _ethers.BrowserProvider(window.ethereum);
              _context2.n = 1;
              return prov.getSigner();
            case 1:
              sig = _context2.v;
              setAddress(acc);
              setProvider(prov);
              setSigner(sig);
              console.log("🔄 MetaMask account switched:", acc);
              _context2.n = 3;
              break;
            case 2:
              disconnectWallet();
              console.log("🟥 MetaMask disconnected or locked");
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function handleAccountChange(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    var handleChainChange = function handleChainChange() {
      console.log("🔁 Network changed, refreshing provider...");
      window.location.reload();
    };
    window.ethereum.on("accountsChanged", handleAccountChange);
    window.ethereum.on("chainChanged", handleChainChange);
    return function () {
      window.ethereum.removeListener("accountsChanged", handleAccountChange);
      window.ethereum.removeListener("chainChanged", handleChainChange);
    };
  }, []);

  // 🧹 Disconnect wallet (manual)
  var disconnectWallet = function disconnectWallet() {
    try {
      setAddress(null);
      setProvider(null);
      setSigner(null);
      delete window.dscProvider;
      delete window.dscSigner;
      delete window.dscAddress;
      console.log("🔒 Wallet disconnected locally");
    } catch (err) {
      console.warn("Disconnect error:", err);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(WalletContext.Provider, {
    value: {
      address: address,
      provider: provider,
      signer: signer,
      connecting: connecting,
      error: error,
      connectWallet: connectWallet,
      disconnectWallet: disconnectWallet
    }
  }, children);
};
var _default = exports["default"] = WalletProvider;